import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import MeasurementFrequencyForm from '../Forms/MeasurementFrequencyForm';

const AddEditMeasurementFrequencyModal = ({
	dataMeasurementFrequency,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Frecuencia de Medición
			</ModalHeader>

			<MeasurementFrequencyForm
				dataMeasurementFrequency={dataMeasurementFrequency}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditMeasurementFrequencyModal;
